import { createFileRoute } from "@tanstack/react-router"

import { PlaceholderPanel } from "@/components/shared/PlaceholderPanel"

export const Route = createFileRoute("/agents/hallucinations")({
  component: () => (
    <PlaceholderPanel
      title="Hallucination Monitor"
      description="Real-time flag display: fabricated citations, unverifiable numbers, assertion conflicts, knowledge cutoff violations"
    />
  ),
})
